<script lang="ts">
import { classname } from '@/js/utils.js';

const classBaseInput = classname('base-input');

export default {
  name: 'BaseInput',
  inheritAttrs: false,
  props: {
    size: {
      type: String,
      default: null,
    },
    modelValue: {
      type: [String, Number, null],
      default: null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {};
  },
  computed: {
    placeholder() {
      return this.modelValue ? null : this.$attrs.placeholder;
    },
    required() {
      if (this.modelValue) {
        return false;
      }
      return Object.keys(this.$attrs).includes('required');
    },
  },
  methods: {
    classBaseInput,
    emitInput({ target }) {
      this.$emit('update:modelValue', target.value);
    },
  },
};
</script>

<template>
  <label :class="classBaseInput({ size })">
    <input
      :value="modelValue"
      :class="classBaseInput('input')"
      v-bind="$attrs"
      @input="emitInput"
    >
    <span :class="classBaseInput('placeholder')">{{ placeholder }}
      <span v-if="required" :class="classBaseInput('placeholder-required')">*</span></span>
  </label>
</template>

<style lang="scss">
.base-input {
  position: relative;
  margin: 0;

  &_size {
    &_sm {
      input {
        padding: 10px;
        font-size: 15px;
      }
    }
  }

  &__placeholder {
    position: absolute;
    top: 50%;
    right: 0;
    left: 0;
    margin: 0 14px;
    overflow: hidden;
    color: #c4c4c4;
    white-space: nowrap;
    transform: translate(0, -50%);
  }

  &__placeholder-required {
    color: red;
  }

  &__input {
    box-sizing: border-box;
    width: 100%;
    padding: 22px 14px;
    font-size: 20px;
    line-height: 1.15;
    background-color: transparent;
    border: 1px solid #c4c4c4;
    border-radius: 2px;
    outline: none;
    transition: border-color 0.3s;

    &:not(:read-only, .error) {
      &:hover,
      &:focus {
        border-color: #000;
      }
    }

    &::placeholder {
      opacity: 0;
    }

    &:read-only {
      color: #c4c4c4;
      cursor: not-allowed;
    }
  }

  input:focus + &__placeholder {
    display: none;
  }

  &.error {
    input {
      border-color: red;
    }
  }

  @media screen and (max-width: 991px) {
    input {
      padding: 14px 24px;
      font-size: 16px;
    }
  }
}
</style>
